import { render, staticRenderFns } from "./TypeCertificateList.vue?vue&type=template&id=14a11228&scoped=true&"
import script from "./TypeCertificateList.vue?vue&type=script&lang=js&"
export * from "./TypeCertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a11228",
  null
  
)

export default component.exports